export default [
    {
        id: 1,
        title: 'Postarcheck',
        sections: [
            {
                type: 'jumbo',
                title: 'Postarcheck',
                subtitle: 'Fast, efficient, lightweight mail management',
                text: 'An effective mail document system for digitalization and automatization of business mail. Available in cloud or on premises.',
                image: '/assets/jumbo-image-postarcheck.png',
            },
            {
                type: 'features',
                title: 'Main features',
                subtitle: 'Digitalization and automatization of business mail',
                features: [{
                    title: 'Control',
                    text: 'By providing easy access to relevant records, it helps in better governance, reduction of associated errors and in improved corporate decision-making.',
                    image: '/assets/pc-icon-4.png',
                },
                {
                    title: 'Performance',
                    text: 'By providing easy access to relevant records, it helps in better governance, reduction of associated errors and in improved corporate decision-making.',
                    image: '/assets/pc-icon-3.png',
                },
                {
                    title: 'Accessibility',
                    text: 'PostarCheck feels at home on every single device. Its cloud solution offers full access to your mail, wherever you are.',
                    image: '/assets/pc-icon-2.png',
                },
                {
                    title: 'Value',
                    text: 'PostarCheck is available for a very reasonable price in a variety of packages. Hosted on a cloud, on your premises or even as an appliance.',
                    image: '/assets/pc-icon.png',
                }],
            },
            {
                type: 'offers',
                title: 'tariff plans',
                subtitle: 'Choose a convenient tariff plan for you',
                offers: [
                    {
                        title: 'Postarcheck Basic',
                        subtitle: 'Everything you need for everyday use',
                        defaultPeriod: 6,
                        pricing: {
                            3: 20,
                            6: 15,
                            12: 10,
                            24: 5,
                        },
                        features: [
                            '1GB of storage for scanned mails',
                            'Up to 3 users',
                            'Up to 120 mails per month',
                            'Excel exports',
                            'Notifications',
                            'Email Reminders',
                            'Online document viewer',
                        ],
                    },
                    {
                        title: 'Postarcheck Plus',
                        subtitle: 'Best value',
                        defaultPeriod: 24,
                        bestValue: true,
                        pricing: {
                            3: 25,
                            6: 20,
                            12: 15,
                            24: 10,
                        },
                        features: [
                            'Postarcheck Basic features',
                            '2 GB of storage for scanned mails ',
                            'Document classification',
                            'Mail scanning',
                            'Daily printouts',
                            'SMS notifications',
                            'Company database (varies by country)',
                        ],
                    },
                    {
                        title: 'Postarcheck Pro',
                        subtitle: 'For enterprises',
                        defaultPeriod: 12,
                        pricing: {
                            3: 35,
                            6: 30,
                            12: 25,
                            24: 20,
                        },
                        features: [
                            '50 GB of storage for scanned mails',
                            'Unlimited users and mails per month',
                            'Custom workflows',
                            'Advanced Document Authorization',
                            'Advanced Document metadata setup',
                            'Mail Content Searching (OCR)',
                            'Label Printing',

                        ],
                    },
                ],
            },
        ],
    },

    {
        id: 2,
        title: 'Veterinarcheck',
        sections: [
            {
                type: 'jumbo',
                title: 'Veterinarcheck',
                subtitle: 'Veterinary Practice Management System',
                text: 'Veterinarcheck is a veterinary practice management software used in animal healthcare centres to assist in daily operations.',
                image: '/assets/jumbo-image-veterinarcheck.png',
                direction: 'right',
            },
            {
                type: 'offers',
                title: 'Tariff Plans',
                subtitle: 'Choose a convenient tariff plan for you',
                offers: [
                    {
                        title: 'Veterinarcheck',
                        subtitle: 'Control your veterinary activities.',
                        defaultPeriod: 12,
                        pricing: {
                            6: 25,
                            12: 22,
                            24: 20,
                        },
                        features: [
                            'Patient Management',
                            'Electronic Health Records',
                        ],
                    },
                    {
                        title: 'Veterinarcheck Plus',
                        subtitle: 'Focus on your primary business.',
                        defaultPeriod: 12,
                        pricing: {
                            6: 35,
                            12: 30,
                            24: 28,
                        },
                        features: [
                            'Veterinarcheck basic features',
                            'Online Appointment System',
                            'BarCode Scanner Integration',
                        ],
                    },
                ],
            },
        ],
    },
];
